import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DeliveryFeeListItem } from "../../financial.types";
import { requestDeliveryFees } from "./getDeliveryFees.request";

const useGetDeliveryFees = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<DeliveryFeeListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["delivery-fees", requestParams],
    queryFn: async () => await requestDeliveryFees(requestParams),
    onError: toastServerError,
    ...options
  });

  return { deliveryFees: data?.data, meta: data?.meta, ...rest };
};

export default useGetDeliveryFees;
